import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Publicás cuando te acordás porque no tenés un calendario y cada día empezás de cero', 'No sabés qué escribir en los captions — mirás la pantalla en blanco durante 20 minutos y no publicás nada', 'Subís stories solo cuando tenés algo nuevo que mostrar — ignorando que la presencia diaria es lo que genera ventas', 'Alguien te pregunta el precio por WhatsApp, vos respondés y la conversación muere — el patrón más común de venta perdida', 'Seguís tutoriales de Canva de 2 horas que no te dan plantillas listas para usar', 'No tenés un sistema de seguimiento de clientes — no sabés quién preguntó y no compró', 'Cada semana te hacés la misma pregunta: "¿qué se supone que tengo que publicar hoy?"'];
  return <section className="py-20 bg-black" data-id="element-228">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-230">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-231">
            ¿Cuántas veces más vas a publicar sin sistema y terminar el mes sin
            ventas?
          </h2>

          <div className="space-y-6 text-lg text-zinc-200 text-left md:text-center max-w-3xl mx-auto" data-id="element-232">
            <p className="text-[14px]" data-id="element-233">
              Querés que tu negocio crezca y que tus redes trabajen para vos.
              Tal vez ya probaste publicar "lo que se te ocurre" y no pasó nada.
              Tal vez seguiste consejos de YouTube que no se adaptaban a tu
              negocio. Tal vez publicaste una semana y después desapareciste
              porque no sabías qué más decir. Tal vez tenés la sensación de que
              "las que venden mucho es porque tienen miles de seguidores" y no
              entendés cómo llegar a eso.
            </p>
            <p data-id="element-234">
              <strong className="text-white text-[16px]" data-id="element-235">
                No es mala suerte. Es que nadie te enseñó cómo funciona el
                sistema desde adentro.
              </strong>
            </p>
            <p className="text-[14px]" data-id="element-236">
              Buscás ideas en Pinterest y encontrás contenido en inglés que no
              aplica. Seguís cuentas de marketing que hablan para empresas
              grandes, no para una emprendedora argentina que trabaja sola.
              Publicás el producto con foto y precio porque "así se hace" sin
              entender que eso no conecta ni vende. Y seguís llegando al final
              de cada semana con la sensación de que "podría haberlo hecho
              mejor."
            </p>
            <p className="font-bold text-white pt-4 text-[14px]" data-id="element-237">
              No es falta de creatividad. Es falta de un sistema.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-red-950/40 border border-red-900/60 rounded-2xl p-6 md:p-8" data-id="element-238">
          <ul className="space-y-4" data-id="element-239">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-240">
                <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-241">
                  <X className="w-4 h-4 text-red-400" data-id="element-242" />
                </div>
                <span className="text-zinc-100 font-medium text-[14px]" data-id="element-243">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-244">
          <p className="font-bold text-violet-400 text-[16px]" data-id="element-245">
            ¿Y si esta fuera la última semana que manejás tu negocio sin un
            sistema real?
          </p>
        </div>
      </div>
    </section>;
}